import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { RoutingLogDetails, RoutingLogQuery } from './routing-log-inspector.model';

@Injectable({
  providedIn: 'root'
})
export class TransportRoutinglogInspectorService {

  constructor(
    private httpService: HttpService
  ) { }

  public findRoutingLogDetails(routingLogKey: string): Observable<RoutingLogDetails> {
    const query = new RoutingLogQuery();
    query.key = routingLogKey;
    return this.httpService.postWithContext<RoutingLogDetails>(environment.routingLogInspectorAdminEndpoint, query)
      .pipe(
        map(rl => new RoutingLogDetails(rl))
      );
  }
}
